import axios from "axios";
import {
    GET_ALL_MODULES_REQUEST,
    GET_ALL_MODULES_SUCCESS,
    GET_ALL_MODULES_FAIL,
    SAVE_ENTITY_MODULES_REQUEST,
    SAVE_ENTITY_MODULES_SUCCESS,
    SAVE_ENTITY_MODULES_FAIL,
    GET_ENTITY_MODULES_REQUEST,
    GET_ENTITY_MODULES_SUCCESS,
    GET_ENTITY_MODULES_FAIL,
} from "../../types/admin/moduleTypes";

export const getAllModulesAction = () => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_ALL_MODULES_REQUEST });

        const {
            sharedLogin: { sharedUserInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: sharedUserInfo.payload.token,
            },
        };

        let companyId;
        if (sharedUserInfo?.payload?.company) {
            companyId = sharedUserInfo?.payload?.company?._id;
        } else if (sharedUserInfo?.empCompanies.length > 0) {
            companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
        }

        const { data } = await axios.get(
            `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/modules/all`,
            config
        );

        dispatch({
            type: GET_ALL_MODULES_SUCCESS,
            payload: data.data,
        });
    } catch (error) {
        dispatch({
            type: GET_ALL_MODULES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const saveEntityModulesAction = (entityId, selectedModuleRoles) => async (dispatch, getState) => {
    try {
        dispatch({ type: SAVE_ENTITY_MODULES_REQUEST });

        const {
            sharedLogin: { sharedUserInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: sharedUserInfo.payload.token,
            },
        };

        let companyId;
        if (sharedUserInfo?.payload?.company) {
            companyId = sharedUserInfo?.payload?.company?._id;
        } else if (sharedUserInfo?.empCompanies.length > 0) {
            companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
        }

        const { data } = await axios.post(
            `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/modules/entity/${entityId}`,
            { selectedModuleRoles },
            config
        );

        dispatch({
            type: SAVE_ENTITY_MODULES_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SAVE_ENTITY_MODULES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getEntityModulesAction = (entityId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_ENTITY_MODULES_REQUEST });

        const {
            sharedLogin: { sharedUserInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: sharedUserInfo.payload.token,
            },
        };

        let companyId;
        if (sharedUserInfo?.payload?.company) {
            companyId = sharedUserInfo?.payload?.company?._id;
        } else if (sharedUserInfo?.empCompanies.length > 0) {
            companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
        }

        const { data } = await axios.get(
            `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/modules/entity/${entityId}`,
            config
        );

        dispatch({
            type: GET_ENTITY_MODULES_SUCCESS,
            payload: data.data,
        });
    } catch (error) {
        dispatch({
            type: GET_ENTITY_MODULES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
